import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';
import { UserAccessComponent } from './components/user-access/user-access.component';
import { FooterNotificationComponent } from './components/footer-notification/footer-notification.component';
import { SharedModule } from '../../shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule, MarkdownModule.forChild()],
  declarations: [UserAccessComponent, FooterNotificationComponent],
  exports: [UserAccessComponent],
})
export class UserAccessModule {}
